// Return a COPY of a QuoteBuilderForm config with its OWN Save and Cancel buttons turned off, for an embedder
// that drives save/cancel from outside the form -- the /mcc setup wizard, where the wizard's Next saves the price
// (through submitRef) and its Back cancels it (through cancelRef). A fresh object, so it never mutates the shared
// or freshly fetched config. Used by both price-step forms: UserUnitPriceCreateForm (machine price) and
// MaterialForm (material price).
const hideFormButtons = (config) => ({
  ...config,
  submit: { ...config.submit, enabled: false },
  cancel: { ...config.cancel, enabled: false },
});

export default hideFormButtons;
